import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import "./DefaultPage.css";

const DefaultPage = (props) => {
  document.title = "Default Page";
  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={
          props.message ? props.message : "Tuto stránku jsme bohužel nenašli"
        }
        text={props.text}
      />
      <div className="container container-background d-flex flex-column align-items-center p-5">
        <img
          src="/images/sad-face.svg"
          alt="error"
          className="error-icon"
        ></img>
        <h2 className="mt-2">Jejda, chyba...</h2>
      </div>
      <Footer />
    </div>
  );
};
export default DefaultPage;

